import React, { FC } from 'react';

import { Icon } from '@iconify/react';
import { IconButton, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { useThemeMode } from '~/contexts/ThemeModeContext';
import analytics from '~/services/analytics';
const ThemeToggle: FC = () => {
  const { t } = useTranslation();
  const { themeMode, toggleTheme } = useThemeMode();
  const isDark = themeMode === 'dark';
  return (
    <Tooltip
      title={
        isDark
          ? t('general:theme_toggle.switch_to_light')
          : t('general:theme_toggle.switch_to_dark')
      }
    >
      <IconButton
        onClick={() => {
          analytics.trackEvent('navigation - light_dark mode switch', {
            theme: isDark ? 'light' : 'dark',
          });
          toggleTheme();
        }}
        sx={{
          color: 'common.black',
          '&:hover': {
            backgroundColor: 'action.hover',
          },
        }}
      >
        <Icon
          icon={isDark ? 'ph:sun-bold' : 'ph:moon-bold'}
          width={20}
          height={20}
        />
      </IconButton>
    </Tooltip>
  );
};
export default ThemeToggle;
